import CONTRACT_STATUSES from './contractStatuses';

const CONTRACT_STATUS_OPTIONS = [
  { title: 'Pending Creation', value: CONTRACT_STATUSES.PENDING_CREATION },
  { title: 'Sent to Contracts', value: 1 },
  { title: 'Sent to Client', value: 2 },
  { title: 'Returned for Signature', value: 3 },
  { title: 'Complete', value: 4 },
  { title: 'N/A', value: CONTRACT_STATUSES.NA }
];

export default CONTRACT_STATUS_OPTIONS;
